import Immutable from 'immutable'
import { actionTypes } from 'actions/actionTypes'

export const boxSummaryReducers = {
  boxSummaryShow: (state = Immutable.fromJS({ show: false, view: '', dismissed: false }), action) => {
    switch (action.type) {
    case actionTypes.BOXSUMMARY_VISIBILITY_CHANGE:
      return Immutable.fromJS({ show: action.show, view: action.view, dismissed: !action.show })
    default:
      return state
    }
  },
  boxSummaryDeliveryDays: (state = Immutable.Map({}), action) => {
    switch (action.type) {
    case actionTypes.BOXSUMMARY_DELIVERY_DAYS_RECEIVE:
      return Immutable.fromJS(action.days)
    default:
      return state
    }
  },
  // Bumped at the start of every boxSummaryDeliveryDaysLoad call, regardless of postcode - lets a
  // request identify whether a newer one has started since, even for the same postcode (which a
  // postcode-only staleness check can't distinguish).
  boxSummaryDeliveryDaysRequestId: (state = 0, action) => {
    switch (action.type) {
    case actionTypes.BOXSUMMARY_DELIVERY_DAYS_REQUEST_START:
      return state + 1
    default:
      return state
    }
  },
  // Tracks how many boxSummaryDeliveryDaysLoad calls are currently in flight, regardless of which
  // one "wins" (its own requestId still matching when it settles) or is discarded as stale.
  // Whichever request finishes last is guaranteed to be the latest one started, so once this hits
  // zero, boxSummaryDeliveryDays is guaranteed to reflect the most recently started request -
  // consumers can safely gate on this being zero rather than trying to identify a winner directly.
  boxSummaryDeliveryDaysPendingCount: (state = 0, action) => {
    switch (action.type) {
    case actionTypes.BOXSUMMARY_DELIVERY_DAYS_REQUEST_START:
      return state + 1
    case actionTypes.BOXSUMMARY_DELIVERY_DAYS_REQUEST_END:
      return Math.max(0, state - 1)
    default:
      return state
    }
  },
  boxSummaryDeliveryDaysErr: (state = null, action) => {
    switch (action.type) {
    case actionTypes.BOXSUMMARY_DELIVERY_DAYS_RECEIVE_ERROR:
      return Immutable.fromJS(action.err)
    case actionTypes.BOXSUMMARY_DELIVERY_DAYS_RECEIVE:
      return null
    default:
      return state
    }
  },
}
